/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { sp } from '@pnp/sp/presets/all';
import * as auth from 'src/app/auth';
import { SideBarService } from 'src/app/services/side-bar.service';
import { ListTitles } from 'src/app/services/constants';
import { HelpMaterialsConfiguration } from 'src/app/services/models';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {



  get isLoggedOut(): boolean {
    return auth.isLoggedOut;
  }

  isSignInDisabled = false;
  showInfo = false;
  showVideo = false;
  
  actualVideoUrl = "";
  helpMaterialsConfigurations: HelpMaterialsConfiguration[];

  constructor(public router: Router,
    public sidebar: SideBarService) {
  }

  async ngOnInit(): Promise<void> {
    const helpMaterialsConfigurationPromise = sp.web.lists.getByTitle(ListTitles.HelpMaterialsConfiguration).items.get();
    this.helpMaterialsConfigurations = await helpMaterialsConfigurationPromise;
    this.helpMaterialsConfigurations.sort((a, b) => a["SortOrder"] - b["SortOrder"]);
  }



  get isOverlayVisible(): boolean {
    return this.sidebar.isSideBarOpen || this.showVideo == true;
  }

  getUrl(link: any): any {
    return link["Url"];
  }

  viewVideo(url: string): void {
    this.actualVideoUrl = url;
    this.showVideo = true;
  }

  closeOverlay(): void {
    this.actualVideoUrl = "";
    this.showVideo = false;
    if (!this.sidebar.blockOverlay) {
      this.sidebar.hide();
    }
  }
  navigateToTaxonomy() {
    
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/glossary`])
    );
  
    window.open(url, '_blank');
  } 
}
